import api from "../sharedInterceptors";

api.defaults.baseURL = process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1;

class DfciAPI {
  async getDfciGridApi(zoomLevel, minx, miny, maxx, maxy) {
    return await api.get(
      `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/dfci/dfci-by-zoom/`,
      {
        params: {
          zoom_level: zoomLevel,
          minx: minx,
          miny: miny,
          maxx: maxx,
          maxy: maxy,
        },
      },
    );
  }

}

export default DfciAPI;
